/**
 * Cart / subscription item `type` values (orderItem.plan.type, addon.type, etc.).
 */
export const ItemType = {
  PLAN: 'plan',
  ADDON: 'addon',
  CHARGE: 'charge',
  PLAN_SETUP: 'plan_setup',
  COUPON: 'coupon',
};

/**
 * Estimate / invoice line_item `entity_type` values (PC1 + PC2).
 */
export const LineItemEntityType = {
  PLAN: ItemType.PLAN,
  ADDON: ItemType.ADDON,
  PLAN_SETUP: ItemType.PLAN_SETUP,
  PLAN_ITEM_PRICE: 'plan_item_price',
  ADDON_ITEM_PRICE: 'addon_item_price',
  CHARGE_ITEM_PRICE: 'charge_item_price',
};

export const PLAN_LINE_ENTITY_TYPES = new Set([
  LineItemEntityType.PLAN,
  LineItemEntityType.PLAN_ITEM_PRICE,
]);

export const ADDON_LINE_ENTITY_TYPES = new Set([
  LineItemEntityType.ADDON,
  LineItemEntityType.ADDON_ITEM_PRICE,
]);
